'use strict';
// https://github.com/zloirock/core-js/issues/280
var userAgent = require('../internals/engine-user-agent');

module.exports = /Version\/10(?:\.\d+){1,2}(?: [\w./]+)?(?: Mobile\/\w+)? Safari\//.test(userAgent);



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/string-pad-webkit-bug.js
// module id = 603
// module chunks = 0